import { panelThemeClasses } from "../../theme/themeClasses";

/** @deprecated Use the semantic Tailwind tokens directly (bg-surface, bg-card, text-content, border-line…). */
export const buildThemeClasses = () => panelThemeClasses();
